import "./PaperWalletPanel.scss";
import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { getPaperWallet, resetPaperBalance } from "../../actions/setting-action";
import PaperCrossTab from "./PaperCrossTab";
import PaperDepositWithdraw from "./PaperDepositWithdraw";
import PaperIsolatedTab from "./PaperIsolatedTab";
import PaperSpotTab from "./PaperSpotTab";
import PaperTransferModal from "./PaperTransferModal";
import ConfirmationModal from "../common/ConfirmationModal";
import { connect, useSelector } from "react-redux";

import { AccountName, AccountType } from "../../Const";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const tabTitles = [AccountName.spot];
const tabTypes = [AccountType.spot];
const PaperWalletPanel = (props) => {
  const {t} = useTranslation()
  const { getPaperWallet,resetPaperBalance } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [showDeposit, setShowDeposit] = useState(false);
  const [isDeposit, setIsDeposit] = useState(true);
  const [showTransfer, setShowTransfer] = useState(false);
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const {
    coins,
    crossCoins,
    pairs,
    risk,
    totalSpot,
    totalCross,
    totalEquityCross,
    totalDebtCross,
    totalIsolated,
    totalEquityIsolated,
    totalDebtIsolated,
  } = useSelector((state) => state.settings.paperWallet) || {};

  const total = (totalSpot || 0) + (totalCross || 0) + (totalIsolated || 0);
  useEffect(() => {
    tabTypes.forEach((el) => {
      getPaperWallet(el).then(console.log);
    });
  }, []);

  useEffect(() => {
    getPaperWallet(tabTypes[activeTab]).then(console.log);
  }, [activeTab]);

  const tabHeaders = tabTitles.map((item, index) => {
    return (
      <Col xs={4} xl={2} key={index}>
        <a
          onClick={() => setActiveTab(index)}
          className={index == activeTab ? "list-tab tab-active" : "list-tab tab-inactive"}
        >
          {item}
        </a>
      </Col>
    );
  });
  const walletTabs = [
    <PaperSpotTab coins={coins} totalSpot={totalSpot} />
  ];
  const clickDeposit = () => {
    setShowDeposit(true);
    setIsDeposit(true);
  };
  const clickWithdraw = () => {
    setShowDeposit(true);
    setIsDeposit(false);
  };
  const clickResetPaperWallet = async () => {
    if (!showResetConfirm || isResetting) return;
    setIsResetting(true);
    try {
      const res = await resetPaperBalance();
      toast.success(res);
      setShowResetConfirm(false);
    } catch (err) {
      toast.error(err);
    } finally {
      setIsResetting(false);
    }
  };
  return (
      <>
      <div className="col-sm-10 setting-right-col">
          <div className="settings-PaperWallet-area">
            <div className="settings-PaperWallet-heading">
              <div className="row spw-heading-row align-items-center">
                <div className="col-xl-6">
                  <div className="spw-headong-left">
                    <button><img src="/images/icon-crash.svg" alt=""/></button>
                    <label>
                      <span>Total</span>
                      <h6>{(totalSpot || 0).toFixed(6)} USD</h6>
                    </label>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="spw-headong-right">
                    <button onClick={clickDeposit}>Add</button>
                    <button onClick={clickWithdraw}>Reduce</button>
                    <button type="button" onClick={() => setShowResetConfirm(true)} disabled={isResetting}>{t("paper-wallet-reset-all-balances")}</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="paperwallet-table-area">
              <div className="paperwallet-btn">
                <button className="pwtbtnactive">{AccountName.spot}</button>
              </div>
              <PaperSpotTab coins={coins} totalSpot={totalSpot}></PaperSpotTab>
            </div>
          </div>
        </div>
      <PaperDepositWithdraw
        show={showDeposit}
        onHide={() => setShowDeposit(false)}
        isDeposit={isDeposit}
        setIsDeposit={setIsDeposit}
        t={t}
      />
      <PaperTransferModal show={showTransfer} onHide={setShowTransfer} />
      <ConfirmationModal
        show={showResetConfirm}
        title={t("paper-wallet-reset-all-balances")}
        body={<>
          <p>{t("paper-wallet-reset-warning")}</p>
          <p className="mb-0">{t("paper-wallet-reset-question")}</p>
        </>}
        onCancel={() => !isResetting && setShowResetConfirm(false)}
        onConfirm={clickResetPaperWallet}
        confirmText={t(isResetting ? "paper-wallet-resetting" : "paper-wallet-reset-all-balances")}
        cancelText={t("cancel")}
        confirmButtonClass="red-button"
        isSubmitting={isResetting}
      />
    </>
  );
};

export default connect(null, { getPaperWallet, resetPaperBalance })(PaperWalletPanel);
